// Centralized API base URLs for the CRA frontend
// Values come from REACT_APP_… variables (CRA exposes only these).
const required = (name, fallback = undefined) => {
  const v = process.env[name];
  if (typeof v === "undefined") return fallback;
  return v;
};

// Railway backend (Express)
export const API_BASE = required("REACT_APP_API_BASE_URL", "http://localhost:5001");

// Stripe serverless API (Vercel)
export const STRIPE_API_BASE =
  required("REACT_APP_STRIPE_API_BASE_URL", "https://stripe-api-nu.vercel.app");

// Optional legacy (kept for toggling if needed)
export const USE_LEGACY_STRIPE = (required("REACT_APP_USE_LEGACY_STRIPE", "false") || "false")
  .toString()
  .toLowerCase() === "true";

export const LEGACY_STRIPE_API_BASE =
  required("REACT_APP_STRIPE_API_BASE_URL_LEGACY", "https://stripe-api-nu.vercel.app");

export const stripeBase = USE_LEGACY_STRIPE ? LEGACY_STRIPE_API_BASE : STRIPE_API_BASE;

// Helpers
export const api = {
  backend: (p) => `${API_BASE}${p.startsWith("/") ? p : `/${p}`}`,
  stripe:  (p) => `${stripeBase}${p.startsWith("/") ? p : `/${p}`}`,
};

export default api;
